import * as ReactTagLoader from "OK/react-tag-loader";
import { IPopupNode } from "@ok/interfaces/popup/Popup";

const POP_LAYER_CONTAINER_ID = 'hook_Block_PopLayerReact';

class ReactPopup {
    private element!: HTMLElement;
    private tagName?: string;

    getReactTag(props: Record<string, any>) {
        const container = document.getElementById(POP_LAYER_CONTAINER_ID)!;
        return ReactTagLoader.getTag<IPopupNode>(this.tagName!, null, container, props);
    }

    clickHandler = () => {
        const props = this.element.getAttribute("data-props")
        const tagProps = props ? JSON.parse(props) : {};
        this.tagName = this.element.getAttribute("data-tag-name")!;
        if (!this.tagName) {
            window.OK.logging.info('An element has no tag name!');
        }

        this.getReactTag(tagProps)
            .then((node) => node.open())
            .catch(() => window.OK.logging.info('An error occurred while opening the popup'));
    }

    activate(el: HTMLElement) {
        this.element = el;

        this.element.addEventListener('click', this.clickHandler);
    }

    deactivate() {
        this.element.removeEventListener('click', this.clickHandler);
    }
}

export default ReactPopup;
